import { RequestSender, useBackendApi } from 'nekst-api';

export default function useProjectsApi(): RequestSender {
  return useBackendApi();
}
